"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import logo_dark from "~/public/icon/logo/logo_dark.svg";
import logo_light from "~/public/icon/logo/logo_light.svg";

type LogoProps = {
  onClick?: (_e: React.MouseEvent<HTMLAnchorElement>) => void;
  isDarkMode?: boolean;
};

/**
 * ロゴ
 */
export default function Logo({ onClick, isDarkMode }: LogoProps) {
  const [logo, setLogo] = useState(logo_light);

  /**
   * モード切替検出
   */
  useEffect(() => {
    //------------
    // モードを切り替え
    //------------
    if (isDarkMode) {
      setLogo(logo_dark);
    } else {
      setLogo(logo_light);
    }
  }, [isDarkMode]);

  return (
    <Link
      href="/"
      onClick={onClick}
    >
      <Image
        alt="Logo"
        src={logo}
        className="h-8 w-auto rounded-sm"
        // width={20}
        height={40}
      />
    </Link>
  );
}
